import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { RapportIncidentTypeIncident, TypeIntervention } from 'src/api/models';

@Component({
  selector: 'app-rapport-incident-type-select',
  templateUrl: './rapport-incident-type-select.component.html',
  styleUrls: ['./rapport-incident-type-select.component.css']
})
export class RapportIncidentTypeSelectComponent implements OnInit {
  @Input() public id: number;
  @Output() idChange = new EventEmitter<number>();
  @Input() width: number;
  @Input() cell: any;

  @Input() disabled: boolean = false;

  rapportsTypes = [];

  constructor(private translateService: TranslateService) { 
    for (var t in RapportIncidentTypeIncident) {
      let value = parseInt(t, 10);
      var isValueProperty = (value >= 0);
      if (isValueProperty) {
        this.rapportsTypes.push({ id: value, name: this.translateService.instant('Rapports.RapportsIncidents.TypesIncidents.' + RapportIncidentTypeIncident[t])});
      }
    } 
  }

  ngOnInit(): void {}

  valueChanged(e) {
    if (!!this.cell) {
      this.cell.setValue(this.id);
    }    

    this.idChange.emit(this.id);
  }  
}
